<template lang="pug">
  action-buttons(:actions="actions", v-if="entity && actions.length", :type='type')
  .dropdown-buttons(v-else-if="entity")
    span No actions available
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "src/maggieHelper";
  import SubscriptionSmartEdit from "../../../backoffice/smartedits/SubscriptionEdit";
  import ActionButtons from "./ActionButtons";

  export default {
    name: "SubscriptionActionButtons",
    components: {ActionButtons, SubscriptionSmartEdit},
    data() {
      return {
        entity: null
      }
    },
    created() {
      if (!this.subscription) {
        KeplerBackofficeSdk.subscriptions.select(this.$route.params.id).get((data) => {
          this.entity = data
        })
      } else {
        this.entity = this.subscription
      }
    },
    methods: {
      remove() {
        this.$confirm('Are you sure?', 'Do you really want to <strong>Delete</strong> the subsription <strong>' + this.entity.id + '</strong>?', () => {
          KeplerBackofficeSdk.subscriptions.select(this.entity.id).remove(() => {
            MaggieHelper.notification('delete-esit', "Subscription deleted")
          })
        })
      },
      renew() {
        this.$confirm('Are you sure?', 'Do you really want to <strong>Renew</strong> the subsription <strong>' + this.entity.id + '</strong>?', () => {
          KeplerBackofficeSdk.subscriptions.select(this.entity.id).renew(function () {
            MaggieHelper.notification('renew-esit', "Subscription renewed")
          })
        })
      },
      disable() {
        this.$confirm('Are you sure?', 'Do you really <strong>Void</strong> the subscription <strong>' + this.entity.id + '</strong>?', () => {
          KeplerBackofficeSdk.subscriptions.select(this.entity.id).disable(function () {
            MaggieHelper.notification('void-esit', "Subscription voided")
          })
        })
      },
      edit() {
        MaggieHelper.openRightPanel({
          component: SubscriptionSmartEdit,
          props: {
            item: this.entity
          }
        })
      }
    },
    props: ['subscription', 'item', 'type'],
    computed: {
      actions() {
        const arr = []
        const aclMap = new Map([[
          'renew-subscriptions', {
            name: 'Renew',
            callback: this.renew,
            severity: 'success'
          }], [
          'void-subscription-subscriptions', {
            name: 'Void',
            callback: this.disable,
            severity: 'alert'
          }], [
          'edit-subscriptions', {
            name: 'Edit',
            callback: this.edit,
            severity: 'alert'
          }], [
          'delete-subscriptions', {
            name: 'Delete',
            callback: this.remove,
            severity: 'alert'
          }]
        ])
        aclMap.forEach((val, key) => {
          if (this.$acl(key)) {
            arr.push(val)
          }
        })
        return arr
      },
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// SubscriptionActionButtons.vue?ae677168